import React from 'react'
import { Box, Heading, VStack } from '@chakra-ui/react'

type Props = {
    title: string
    children: React.ReactNode
}

export const Page = ({ title, children }: Props) => {
    return (
        <VStack align="stretch" gap={6}>
            <Heading size="lg">{title}</Heading>
            <Box>{children}</Box>
        </VStack>
    )
}
